// Styles for MemberShipTiersBenefits go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledMemberShipTiersBenefits = styled.div`
  .membership-tiers-skeleton__title {
    width: ${toRem(200)};
    height: ${toRem(28)};
    margin-top: ${toRem(20)};
  }
  .membership-tiers-skeleton__tab {
    width: ${toRem(80)};
    height: ${toRem(36)};
  }
  .membership-tiers-skeleton__eyebrow {
    width: ${toRem(120)};
    height: ${toRem(14)};
  }
  .membership-tiers-skeleton__heading {
    width: ${toRem(160)};
    height: ${toRem(24)};
  }
  .membership-tiers-skeleton__tagline {
    width: ${toRem(240)};
    height: ${toRem(16)};
  }
  .membership-tiers-skeleton__icon {
    width: ${toRem(40)};
    height: ${toRem(40)};
    border-radius: 50%;
  }
  .membership-tiers-skeleton__card-title {
    width: ${toRem(120)};
    height: ${toRem(18)};
  }
  .membership-tiers-skeleton__card-desc {
    width: ${toRem(180)};
    height: ${toRem(14)};
  }

  .account-table-skeleton__header {
    width: 100%;
    height: ${toRem(28)};
  }
  .account-table-skeleton__col-header {
    width: ${toRem(120)};
    height: ${toRem(48)};
  }
  .account-table-skeleton__row {
    border-bottom: 1px solid ${baseVariables.color['neutral30']};
  }
  .account-table-skeleton__row-label {
    width: ${toRem(300)};
    height: ${toRem(18)};
  }
  .account-table-skeleton__cell {
    width: ${toRem(120)};
    height: ${toRem(20)};
  }
`;

export const StyledMembershipTiersView = styled.section`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${toRem(32)};
  padding: ${toRem(48)} ${toRem(16)};
  border-radius: ${toRem(16)};
  background-color: ${baseVariables.color['base20']};
  box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);

  @media ${baseVariables.mediaQuery.md} {
    padding-inline: ${toRem(24)};
  }

  @media ${baseVariables.mediaQuery.lg} {
    padding-inline: ${toRem(32)};
  }

  .membership-tiers__heading {
    margin: 0;
    text-align: center;
  }

  .membership-tiers__panel {
    display: flex;
    flex-direction: column;
    gap: ${toRem(32)};
  }

  .tier-hero {
    text-align: center;
    gap: ${toRem(8)};
  }

  .tier-hero__eyebrow {
    text-transform: uppercase;
    font-weight: ${baseVariables.font.fontWeightMedium};
    color: ${baseVariables.color['neutral40']};
    margin: 0;
  }

  .tier-hero__title {
    margin: 0;
  }

  .tier-hero__tagline {
    margin: 0;
  }

  .benefits-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: ${toRem(32)};

    @media ${baseVariables.mediaQuery.md} {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: ${toRem(32)} ${toRem(24)};
    }

    @media ${baseVariables.mediaQuery.lg} {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: ${toRem(32)} ${toRem(32)};
    }
  }

  .benefit-card {
    text-align: center;
    width: 100%;
    padding-inline: ${toRem(8)};

    @media ${baseVariables.mediaQuery.md} {
      padding-inline: ${toRem(12)};

      &:last-child:nth-child(odd) {
        grid-column: 1 / -1;
      }
    }

    @media ${baseVariables.mediaQuery.lg} {
      padding-inline: ${toRem(16)};

      &:last-child:nth-child(odd) {
        grid-column: auto;
      }
    }
  }

  .benefit-card__icon-wrap {
    margin-bottom: ${toRem(12)};
    color: ${baseVariables.color.accent10};

    .benefit-icon {
      &::before {
        font-size: ${toRem(40)};
        height: ${toRem(40)};
        width: ${toRem(40)};
      }
    }
  }

  .benefit-card__description {
    color: ${baseVariables.color['neutral40']};
  }
`;
